import React, { useEffect, useState } from "react";
import { Table, Pagination, Spinner, Tabs, Tab } from "react-bootstrap";
import NavbarComponent from "../layout/NavbarComponent";
import Footer from "../layout/Footer";
import { Layout } from "../layout/Layout";
import PaginationComponent from "./PaginationComponent";

const API_URL = process.env.REACT_APP_API_URL;

const Payment = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [totalPages, setTotalPages] = useState(0);

  // NEW: active tab
  const [activeTab, setActiveTab] = useState("bronze");

  // Decide API based on tab
  // const getApiEndpoint = () => {
  //   switch (activeTab) {
  //     case "bronze":
  //       return `${API_URL}/pricing/bronze`;
  //     case "silver":
  //       return `${API_URL}/pricing/silver`;
  //     case "gold":
  //       return `${API_URL}/pricing/gold`;
  //     default:
  //       return `${API_URL}/pricing/bronze`;
  //   }
  // };
const getApiEndpoint = () => {
  return `${API_URL}/pricing/${activeTab}`;
};
  const fetchPayments = () => {
    setLoading(true);

    fetch(`${getApiEndpoint()}?page=${page}&size=${size}`)
      .then((res) => res.json())
      .then((data) => {
        setPayments(data.content || []);
        setTotalPages(data.totalPages || 0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching payments:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPayments();
  }, [page, size, activeTab]);

  return (
   <Layout>
    <div className="payments-page">
        <div className="payments-container">

            {/* Heading */}
            <div className="payments-heading-row">
                <div>
                    <h2 className="payments-title">Payments</h2>
                    <p className="payments-subtitle">
                        {payments.length} {payments.length === 1 ? "transaction" : "transactions"} on this plan
                    </p>
                </div>
            </div>

            {/* Tabs */}
            <div className="payments-tabs" role="tablist">
                {["bronze", "silver", "gold"].map((tier) => (
                    <button
                        key={tier}
                        role="tab"
                        aria-selected={activeTab === tier}
                        className={`payments-tab ${activeTab === tier ? "payments-tab--active" : ""}`}
                        onClick={() => {
                            setActiveTab(tier);
                            setPage(0);
                        }}
                    >
                        {tier.charAt(0).toUpperCase() + tier.slice(1)}
                    </button>
                ))}
            </div>

            {/* Loading */}
            {loading ? (
                <div className="payments-loading">
                    <Spinner animation="border" style={{ color: "#e07b39" }} />
                </div>
            ) : payments.length === 0 ? (
                <div className="payments-empty">
                    <div className="payments-empty-badge">0</div>
                    <p className="payments-empty-text">No data found</p>
                    <p className="payments-empty-sub">No {activeTab} payments to show yet.</p>
                </div>
            ) : (
                <>
                    {/* Table Card Wrapper */}
                    <div className="payments-card">
                        <div className="table-responsive">
                            <Table className="payments-table mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>User Name</th>
                                        <th className="d-none d-md-table-cell">User Email</th>
                                        <th>Pet Name</th>
                                        <th className="d-none d-lg-table-cell">Transaction ID</th>
                                        <th>Amount</th>
                                        <th className="d-none d-md-table-cell">Currency</th>
                                        <th className="d-none d-lg-table-cell">Country</th>
                                        <th>Active Plan</th>
                                        <th>Payment At</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {payments.map((payment) => (
                                        <tr key={payment.paymentId}>
                                            <td className="payments-id">{payment.paymentId}</td>
                                            <td className="fw-semibold">{payment.userName}</td>
                                            <td className="d-none d-md-table-cell text-break text-muted">
                                                {payment.userEmail}
                                            </td>
                                            <td>{payment.petName}</td>
                                            <td
                                                className="d-none d-lg-table-cell text-truncate text-muted"
                                                style={{ maxWidth: "180px" }}
                                            >
                                                {payment.transactionId}
                                            </td>
                                            <td className="payments-amount">
                                                {payment.paymentAmount}
                                            </td>
                                            <td className="d-none d-md-table-cell text-muted">
                                                {payment.paymentCurrency}
                                            </td>
                                            <td className="d-none d-lg-table-cell text-muted">
                                                {payment.country}
                                            </td>
                                            <td>
                                                <span className="payments-pill">
                                                    {payment.planType}
                                                </span>
                                            </td>
                                            <td className="text-muted">{payment.paymentAt}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    {/* Pagination Section */}
                    <div className="payments-pagination">
                        <PaginationComponent
                            page={page}
                            setPage={setPage}
                            size={size}
                            setSize={setSize}
                            totalPages={totalPages}
                        />
                    </div>
                </>
            )}
        </div>
    </div>

    <style>{`
        .payments-page {
            min-height: 100vh;
            background: #F7F8F6;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', sans-serif;
        }

        .payments-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
            flex: 1;
        }

        .payments-heading-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 22px;
        }

        .payments-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .payments-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .payments-tabs {
            display: inline-flex;
            background: #EFF1EC;
            border-radius: 10px;
            padding: 4px;
            gap: 4px;
            margin-bottom: 22px;
        }

        .payments-tab {
            border: none;
            background: transparent;
            padding: 8px 20px;
            border-radius: 7px;
            font-size: 13.5px;
            font-weight: 600;
            color: #5C6862;
            cursor: pointer;
            transition: all 0.15s ease;
        }

        .payments-tab:hover {
            color: #1C2420;
        }

        .payments-tab--active {
            background: #e07b39;
            color: #fff;
            box-shadow: 0 1px 3px rgba(224, 123, 57, 0.35);
        }

        .payments-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 64px 0;
        }

        .payments-empty {
            text-align: center;
            padding: 72px 20px;
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
        }

        .payments-empty-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(224, 123, 57, 0.1);
            color: #e07b39;
            font-weight: 700;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
        }

        .payments-empty-text {
            font-weight: 600;
            font-size: 17px;
            color: #1C2420;
            margin: 0 0 4px;
        }

        .payments-empty-sub {
            font-size: 13.5px;
            color: #8B978F;
            margin: 0;
        }

        .payments-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
        }

        .payments-table thead {
            background: rgba(224, 123, 57, 0.06);
        }

        .payments-table thead th {
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 700;
            color: #B8632C;
            padding: 13px 14px;
            border-bottom: 1px solid #F0E4D8;
            white-space: nowrap;
        }

        .payments-table tbody td {
            padding: 13px 14px;
            font-size: 13.5px;
            color: #333B36;
            border-bottom: 1px solid #F2F3F0;
            vertical-align: middle;
        }

        .payments-table tbody tr:last-child td {
            border-bottom: none;
        }

        .payments-table tbody tr:hover {
            background: #FBFAF8;
        }

        .payments-id {
            font-weight: 600;
            color: #5C6862;
        }

        .payments-amount {
            font-weight: 700;
            color: #1C2420;
        }

        .payments-pill {
            display: inline-block;
            padding: 4px 11px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            background: rgba(224, 123, 57, 0.14);
            color: #B8632C;
            text-transform: capitalize;
        }

        .payments-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    `}</style>
</Layout>

  );
};

export default Payment;
